"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _AuthProvider = require("./AuthProvider");
Object.keys(_AuthProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AuthProvider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AuthProvider[key];
    }
  });
});
var _UserAnalytics = require("./UserAnalytics");
Object.keys(_UserAnalytics).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UserAnalytics[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _UserAnalytics[key];
    }
  });
});
var _useIdentity = require("./useIdentity");
Object.keys(_useIdentity).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useIdentity[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useIdentity[key];
    }
  });
});
var _matomoAnalytics = require("./matomoAnalytics");
Object.keys(_matomoAnalytics).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _matomoAnalytics[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _matomoAnalytics[key];
    }
  });
});